/*
  Pinnacle Garage USA - header-style Year / Make / Model dropdowns + trims + factory (OEM) wheels.
  Upgrades every <select data-role="year|make|model"> inside the Shop by Vehicle search (.pg-ymm) and the
  Wheel Size Guide (.pg-tg). The native selects stay in place (hidden) and keep driving the original logic.

  EDITING DATA
  PG_TRIMS  "Make|Model label": "Trim:fromYear-toYear, Trim:fromYear-toYear, ..."
  PG_OEM    "Make|Model label": [[wheel name, fromYear, toYear, [trims] or null for all, "sizes"], ...]
            Only factory wheels we are confident about are listed; anything else shows "coming soon".
*/
window.PG_TRIMS = {
  "Acura|RSX": "Base:2002-2006, Type-S:2002-2006",
  "Acura|TSX": "2.4:2004-2014, V6:2010-2014, Sport Wagon:2011-2014",
  "Acura|TL": "Base:2004-2014, Type-S:2007-2008, SH-AWD:2009-2014",
  "Acura|TLX": "2.4:2015-2020, 3.5 V6:2015-2020, Base:2021-2026, A-Spec:2019-2026, Type S:2021-2026",
  "Acura|Integra": "LS:1994-2001, GS:1994-2001, GS-R:1994-2001, Type R:1997-2001, Base:2023-2026, A-Spec:2023-2026, Type S:2024-2026",
  "Acura|ILX": "Base:2013-2022, Premium:2013-2022, A-Spec:2016-2022",

  "Audi|A4 / S4 (B8)": "A4 2.0T:2009-2016, S4:2010-2016",
  "Audi|A4 / S4 (B9)": "A4:2017-2026, S4:2018-2026",
  "Audi|A5 / S5 / RS5 (B8)": "A5:2008-2017, S5:2008-2017, RS5:2013-2015",
  "Audi|A5 / S5 / RS5 (B9)": "A5:2018-2026, S5:2018-2026, RS5:2018-2026",
  "Audi|A6 / S6 (C7)": "A6 2.0T:2012-2018, A6 3.0T:2012-2018, S6:2013-2018",
  "Audi|A6 / S6 (C8)": "A6:2019-2026, S6:2020-2026",
  "Audi|A7 / S7 / RS7": "A7:2012-2026, S7:2013-2026, RS7:2014-2026",
  "Audi|A3 / S3 / RS3": "A3:2015-2026, S3:2015-2026, RS3:2017-2026",
  "Audi|TT / TTS / TT RS": "TT:2008-2023, TTS:2009-2023, TT RS:2012-2022",

  "BMW|1 Series (E82/E88)": "128i:2008-2013, 135i:2008-2013, 135is:2013-2013",
  "BMW|2 Series (F22/F23)": "228i:2014-2016, 230i:2017-2021, M235i:2014-2016, M240i:2017-2021",
  "BMW|2 Series Coupe (G42)": "230i:2022-2026, M240i:2022-2026",
  "BMW|M2 (F87)": "M2:2016-2018, M2 Competition:2019-2021, M2 CS:2020-2021",
  "BMW|M2 (G87)": "M2:2023-2026",
  "BMW|3 Series (E46)": "323i:1999-2000, 325i:2001-2005, 328i:1999-2000, 330i:2001-2006, 325Ci:2001-2006, 330Ci:2001-2006, 325xi:2001-2005, 330xi:2001-2005",
  "BMW|3 Series (E90/E92/E93)": "328i:2007-2013, 328xi / 328i xDrive:2007-2013, 335i:2007-2013, 335xi / 335i xDrive:2007-2013, 335d:2009-2011, 335is:2011-2013",
  "BMW|3 Series (F30/F31/F34)": "320i:2013-2019, 328i:2012-2016, 330i:2017-2019, 335i:2012-2015, 340i:2016-2019, 328d:2014-2018",
  "BMW|3 Series (G20/G21)": "330i:2019-2026, 330e:2021-2026, M340i:2020-2026",
  "BMW|M3 (F80)": "M3:2015-2018, M3 Competition:2016-2018, M3 CS:2018-2018",
  "BMW|M3 (G80)": "M3:2021-2026, M3 Competition:2021-2026, M3 CS:2024-2025",
  "BMW|4 Series (F32/F33/F36)": "428i:2014-2016, 430i:2017-2020, 435i:2014-2016, 440i:2017-2020",
  "BMW|M4 (F82/F83)": "M4:2015-2020, M4 Competition:2016-2020, M4 GTS:2016-2016, M4 CS:2018-2019",
  "BMW|4 Series (G22/G23/G26)": "430i:2021-2026, M440i:2021-2026",
  "BMW|M4 (G82/G83)": "M4:2021-2026, M4 Competition:2021-2026, M4 CSL:2023-2023",
  "BMW|5 Series (E60/E61)": "525i:2004-2007, 528i:2008-2010, 530i:2004-2007, 535i:2008-2010, 545i:2004-2005, 550i:2006-2010",
  "BMW|5 Series (F10/F11)": "528i:2011-2016, 535i:2011-2016, 550i:2011-2016, 535d:2014-2016",
  "BMW|5 Series (G30/G31)": "530i:2017-2023, 530e:2018-2023, 540i:2017-2023, M550i:2018-2023",
  "BMW|X3 (F25)": "xDrive28i:2011-2017, xDrive35i:2011-2017, xDrive28d:2014-2017",
  "BMW|X3 (G01)": "sDrive30i:2018-2024, xDrive30i:2018-2024, M40i:2018-2024",
  "BMW|X5 (E70)": "xDrive30i:2007-2010, xDrive35i:2011-2013, xDrive48i:2008-2010, xDrive50i:2011-2013, xDrive35d:2009-2013",
  "BMW|X5 (F15)": "sDrive35i:2014-2018, xDrive35i:2014-2018, xDrive50i:2014-2018, xDrive35d:2014-2016, xDrive40e:2016-2018",
  "BMW|X5 (G05)": "sDrive40i:2019-2023, xDrive40i:2019-2026, xDrive45e:2021-2023, xDrive50e:2024-2026, M50i:2020-2023, M60i:2024-2026",
  "BMW|Z4 (E89)": "sDrive30i:2009-2011, sDrive28i:2012-2016, sDrive35i:2009-2016, sDrive35is:2011-2016",
  "BMW|Z4 (G29)": "sDrive30i:2019-2026, M40i:2019-2026",

  "Cadillac|Escalade": "Base:2007-2014, Luxury:2007-2020, Premium Luxury:2015-2026, Platinum:2008-2026, Sport:2021-2026, V:2023-2026",
  "Chevrolet|Camaro": "LS:2010-2024, LT:2010-2024, SS:2010-2024, ZL1:2012-2024, Z/28:2014-2015",
  "Chevrolet|Silverado 1500": "WT:2007-2026, Custom:2016-2026, LT:2007-2026, RST:2019-2026, LTZ:2007-2026, High Country:2014-2026, Trail Boss:2019-2026, ZR2:2022-2026",
  "Chevrolet|Tahoe / Suburban": "LS:2007-2020, LT:2007-2026, Premier:2015-2026, RST:2021-2026, Z71:2021-2026, High Country:2021-2026",
  "Chrysler|300": "Touring / 300:2011-2023, 300S:2012-2023, 300C:2011-2023, SRT8:2012-2014",
  "Dodge|Challenger": "SXT:2011-2023, GT:2017-2023, R/T:2011-2023, R/T Scat Pack:2015-2023, SRT 392:2015-2018, SRT Hellcat:2015-2023, SRT Hellcat Redeye:2019-2023, SRT Demon:2018-2023",
  "Dodge|Charger": "SE / SXT:2011-2023, GT:2017-2023, R/T:2011-2023, Scat Pack:2015-2023, SRT 392:2015-2018, SRT Hellcat:2015-2023, SRT Hellcat Redeye:2021-2023",

  "Ford|Mustang": "V6:2005-2017, EcoBoost:2015-2026, GT:2005-2026, Bullitt:2019-2020, Mach 1:2021-2023, Shelby GT350:2015-2020, Shelby GT500:2007-2014, Shelby GT500 (S550):2020-2022, Dark Horse:2024-2026",
  "Ford|Focus ST": "ST:2013-2018",
  "Genesis|G70": "2.0T:2019-2023, 2.5T:2024-2026, 3.3T:2019-2026",
  "GMC|Sierra 1500": "SLE:2007-2026, SLT:2007-2026, AT4:2019-2026, Denali:2007-2026, Denali Ultimate:2022-2026, Elevation:2019-2026",
  "GMC|Yukon / Yukon XL": "SLE:2007-2026, SLT:2007-2026, AT4:2021-2026, Denali:2007-2026, Denali Ultimate:2023-2026",

  "Honda|Accord": "LX:2003-2026, EX:2003-2026, EX-L:2003-2026, Sport:2013-2026, Touring:2013-2026",
  "Honda|Civic": "DX / LX:2001-2015, EX:2001-2015, Si:2002-2015, HF:2013-2013",
  "Honda|Civic (10th Gen)": "LX:2016-2021, Sport:2017-2021, EX:2016-2021, EX-L:2016-2020, Si:2017-2020, Touring:2016-2021",
  "Honda|Civic Type R (FK8)": "Type R Touring:2017-2021, Type R Limited Edition:2021-2021",
  "Honda|Civic (11th Gen)": "LX:2022-2026, Sport:2022-2026, EX:2022-2026, Touring:2022-2026, Si:2022-2026",
  "Hyundai|Genesis Coupe": "2.0T:2010-2016, 3.8:2010-2016",
  "Infiniti|G35": "Base:2003-2008, x AWD:2004-2008, Journey:2007-2008, Sport:2003-2008",
  "Infiniti|G37 / Q60 Coupe": "Journey:2008-2015, x AWD:2008-2015, Sport:2008-2015, IPL:2011-2015",
  "Infiniti|Q50": "2.0t:2016-2018, 3.0t:2016-2024, Red Sport 400:2016-2024, Hybrid:2014-2018, 3.7:2014-2015",
  "Infiniti|Q60": "2.0t:2017-2019, 3.0t:2017-2022, Red Sport 400:2017-2022",
  "Kia|Stinger": "2.0T / GT-Line:2018-2023, GT:2018-2020, GT1:2018-2023, GT2:2018-2023",

  "Lexus|ES": "ES350:2006-2026, ES300h:2013-2026, ES250:2021-2026",
  "Lexus|GS": "GS300:2006-2006, GS350:2007-2020, GS430:2006-2007, GS460:2008-2011, GS450h:2007-2018, GS200t:2016-2017, GS300 (2.0T):2018-2020, GS F:2016-2020",
  "Lexus|IS (2IS)": "IS250:2006-2013, IS350:2006-2013",
  "Lexus|IS F": "IS F:2008-2014",
  "Lexus|IS (3IS)": "IS250:2014-2015, IS350:2014-2020, IS200t:2016-2016, IS300:2016-2020",
  "Lexus|IS (4IS)": "IS300:2021-2026, IS350:2021-2026, IS500 F Sport Performance:2022-2026",
  "Lexus|RC": "RC350:2015-2026, RC300:2016-2026, RC200t:2016-2017, RC F:2015-2026",
  "Lexus|RX": "RX350:2010-2026, RX450h:2010-2022, RX500h:2023-2026",

  "Mercedes-Benz|C-Class (W204)": "C250:2012-2014, C300:2008-2014, C350:2008-2015, C63 AMG:2008-2015",
  "Mercedes-Benz|C-Class (W205)": "C300:2015-2021, C350e:2016-2018, C400:2015-2015, C450 AMG:2016-2016, C43 AMG:2017-2021, C63 AMG:2015-2021, C63 S AMG:2015-2021",
  "Mercedes-Benz|C-Class (W206)": "C300:2022-2026, C43 AMG:2023-2026, C63 S E Performance:2024-2026",
  "Mercedes-Benz|CLS": "CLS550:2012-2018, CLS400:2015-2017, CLS63 AMG:2012-2018",
  "Mercedes-Benz|E-Class (W212)": "E350:2010-2016, E400:2015-2016, E550:2010-2016, E250 BlueTEC:2014-2016, E63 AMG:2010-2016",
  "Mercedes-Benz|E-Class (W213)": "E300:2017-2018, E350:2019-2023, E400:2017-2018, E450:2019-2023, E43 AMG:2017-2018, E53 AMG:2019-2023, E63 AMG:2018-2023, E63 S AMG:2018-2023",
  "Mercedes-Benz|S-Class (W222)": "S550:2014-2017, S450:2018-2020, S560:2018-2020, S63 AMG:2014-2020, S65 AMG:2015-2020",
  "Mercedes-Benz|S-Class (W223)": "S500:2021-2026, S580:2021-2026",
  "Mitsubishi|Lancer Evolution X": "GSR:2008-2015, MR:2008-2015, Final Edition:2015-2015",

  "Nissan|350Z": "Base:2003-2008, Enthusiast:2003-2008, Performance:2003-2005, Touring:2003-2008, Track:2003-2006, NISMO:2007-2008",
  "Nissan|370Z": "Base:2009-2020, Sport:2009-2020, Touring:2009-2020, NISMO:2009-2020",
  "Nissan|Altima": "S:2013-2026, SV:2013-2026, SR:2013-2026, SL:2013-2026",
  "Nissan|Maxima": "S:2016-2023, SV:2016-2023, SR:2016-2023, SL:2016-2023, Platinum:2016-2023",
  "Porsche|911 (997)": "Carrera:2005-2012, Carrera S:2005-2012, Carrera 4 / 4S:2006-2012, GTS:2011-2012",
  "Porsche|Boxster / Cayman (987)": "Boxster:2005-2012, Boxster S:2005-2012, Cayman:2007-2012, Cayman S:2006-2012",
  "Scion|FR-S": "FR-S:2013-2016, Release Series:2013-2016",
  "Subaru|BRZ": "Premium:2013-2020, Limited:2013-2026, tS:2018-2018, Premium (2nd gen):2022-2026, tS (2nd gen):2024-2026",
  "Subaru|WRX": "Base:2008-2026, Premium:2008-2026, Limited:2008-2026, GT:2022-2026, tS:2024-2026",
  "Subaru|WRX STI": "Base:2008-2021, Limited:2011-2021",

  "Tesla|Model 3": "Standard Range / RWD:2017-2026, Long Range:2017-2026, Performance:2018-2026",
  "Tesla|Model S": "75D / 90D:2015-2019, 100D:2017-2019, P90D / P100D:2015-2019, Long Range:2019-2026, Plaid:2021-2026",
  "Tesla|Model X": "75D / 90D:2016-2019, 100D:2017-2019, P90D / P100D:2016-2019, Long Range:2019-2026, Plaid:2021-2026",
  "Tesla|Model Y": "Long Range:2020-2026, Performance:2020-2026, Standard Range / RWD:2021-2026",

  "Toyota|86 / GR86": "86:2017-2020, GR86:2022-2026, GR86 Premium:2022-2026",
  "Toyota|Camry": "L:2012-2026, LE:2012-2026, SE:2012-2026, XLE:2012-2026, XSE:2018-2026, TRD:2020-2024",
  "Toyota|GR Supra": "2.0:2021-2022, 3.0:2020-2026, 3.0 Premium:2020-2026, A91 Edition:2021-2021",
  "Volkswagen|Golf / GTI": "Golf:2010-2021, GTI S:2010-2026, GTI SE:2015-2026, GTI Autobahn:2010-2026",
  "Volkswagen|Jetta / GLI": "S:2011-2026, SE:2011-2026, SEL:2011-2026, GLI:2012-2026"
};

window.PG_OEM = {
  "BMW|M3 (E46)": [
    ["Style 67", 2001, 2006, null, "18\" staggered \u00b7 F 18x8 ET47 \u00b7 R 18x9 ET26"],
    ["Style 163", 2001, 2006, null, "19\" staggered (option) \u00b7 F 19x8 ET47 \u00b7 R 19x9.5 ET27"]
  ],
  "BMW|M3 (E90/E92/E93)": [
    ["Style 219M", 2008, 2013, null, "18\" staggered \u00b7 F 18x8.5 ET29 \u00b7 R 18x9.5 ET23"],
    ["Style 220M", 2008, 2013, null, "19\" staggered (option)"],
    ["Style 359M", 2011, 2013, null, "19\" staggered (Competition Package)"]
  ],
  "BMW|3 Series (F30/F31/F34)": [
    ["Style 400M", 2012, 2019, null, "18\" staggered (M Sport) \u00b7 F 18x8 ET34 \u00b7 R 18x8.5 ET47"],
    ["Style 403M", 2012, 2019, null, "19\" staggered (M Sport option) \u00b7 F 19x8 ET36 \u00b7 R 19x8.5 ET47"]
  ],
  "BMW|4 Series (F32/F33/F36)": [
    ["Style 400M", 2014, 2020, null, "18\" staggered (M Sport) \u00b7 F 18x8 ET34 \u00b7 R 18x8.5 ET47"],
    ["Style 403M", 2014, 2020, null, "19\" staggered (M Sport option) \u00b7 F 19x8 ET36 \u00b7 R 19x8.5 ET47"]
  ],
  "BMW|M2 (F87)": [
    ["Style 437M", 2016, 2018, ["M2"], "19\" staggered \u00b7 F 19x9 ET29 \u00b7 R 19x10 ET40"],
    ["Style 788M", 2019, 2021, ["M2 Competition"], "19\" staggered"]
  ],
  "BMW|M3 (F80)": [
    ["Style 437M", 2015, 2018, null, "19\" staggered \u00b7 F 19x9 ET29 \u00b7 R 19x10 ET40"],
    ["Style 666M", 2016, 2018, ["M3 Competition", "M3 CS"], "20\" staggered \u00b7 F 20x9 ET29 \u00b7 R 20x10 ET40"]
  ],
  "BMW|M4 (F82/F83)": [
    ["Style 437M", 2015, 2020, null, "19\" staggered \u00b7 F 19x9 ET29 \u00b7 R 19x10 ET40"],
    ["Style 666M", 2016, 2020, ["M4 Competition", "M4 CS", "M4 GTS"], "20\" staggered \u00b7 F 20x9 ET29 \u00b7 R 20x10 ET40"]
  ],
  "Honda|Civic Type R (FK8)": [
    ["Type R 20\" (FK8)", 2017, 2021, null, "20x8.5 ET60 \u00b7 5x120"]
  ],
  "Tesla|Model 3": [
    ["Aero", 2017, 2023, ["Standard Range / RWD", "Long Range"], "18x8.5 ET40"],
    ["Sport", 2017, 2023, ["Standard Range / RWD", "Long Range"], "19x8.5 ET40 (option)"],
    ["Stiletto", 2018, 2020, ["Performance"], "20x8.5 ET35"],
    ["\u00dcberturbine", 2021, 2023, ["Performance"], "20\" (Performance)"],
    ["Photon", 2024, 2026, ["Standard Range / RWD", "Long Range"], "18\""],
    ["Nova", 2024, 2026, ["Standard Range / RWD", "Long Range"], "19\" (option)"],
    ["Warp", 2024, 2026, ["Performance"], "20\" staggered (Performance)"]
  ],
  "Tesla|Model Y": [
    ["Gemini", 2020, 2026, ["Long Range", "Standard Range / RWD"], "19x9.5 ET45"],
    ["Induction", 2020, 2026, ["Long Range", "Standard Range / RWD"], "20x9.5 ET45 (option)"],
    ["\u00dcberturbine", 2020, 2026, ["Performance"], "21\" staggered \u00b7 F 21x9.5 ET40 \u00b7 R 21x10.5 ET40"],
    ["Apollo", 2023, 2026, ["Long Range", "Standard Range / RWD"], "19\""]
  ],
  "Tesla|Model S": [
    ["Slipstream", 2015, 2020, null, "19x8 ET40"],
    ["Arachnid", 2016, 2020, null, "21\" (option)"],
    ["Tempest", 2021, 2026, null, "19\""],
    ["Zero-G", 2021, 2026, ["Plaid"], "21\" (option)"]
  ],
  "Tesla|Model X": [
    ["Slipstream", 2016, 2020, null, "20\""],
    ["Turbine", 2016, 2026, null, "22\" (option)"],
    ["Cyberstream", 2021, 2026, null, "20\""]
  ]
};

(function () {
  var mq = window.matchMedia('(hover: hover) and (min-width: 750px)');
  var RED = '#c8102e';

  var css = [
    '.pgx{position:relative;display:block;width:100%;min-width:0}',
    '.pgx>select{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;opacity:0!important;pointer-events:none!important;z-index:-1}',
    '.pgx-btn{display:flex;align-items:center;justify-content:space-between;gap:1rem;width:100%;min-height:4.6rem;padding:0 1.4rem;margin:0;background:#f3f3f4;color:#111;border:1px solid rgba(0,0,0,.12);border-radius:0;font:inherit;font-size:1.45rem;font-weight:700;letter-spacing:.04em;text-align:left;cursor:pointer;transition:border-color .2s,background .2s}',
    '.pgx-btn>span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0}',
    '.pgx-btn>span.ph{font-weight:400;color:#555}',
    '.pgx-btn::after{content:"";flex:0 0 auto;width:.7rem;height:.7rem;border-right:2px solid #111;border-bottom:2px solid #111;transform:translateY(-25%) rotate(45deg);transition:transform .2s}',
    '.pgx.open .pgx-btn{border-color:' + RED + ';background:#fff}',
    '.pgx.open .pgx-btn::after{transform:translateY(20%) rotate(-135deg)}',
    '.pgx-btn:disabled{opacity:.5;cursor:not-allowed}',
    '.pgx-btn:focus-visible{outline:2px solid ' + RED + ';outline-offset:1px}',
    '.pgx-panel,.pgx-sub{display:none;position:absolute;left:0;top:100%;z-index:1100;min-width:100%;max-height:36rem;overflow-y:auto;margin:0;padding:.8rem 0;list-style:none;background:#f3f3f4;color:#111;border:1px solid rgba(0,0,0,.12);border-top:2px solid ' + RED + ';box-shadow:0 1.6rem 3.2rem rgba(0,0,0,.25);text-align:left}',
    '.pgx.open .pgx-panel{display:block}',
    '.pgx-sub{position:fixed;left:auto;top:auto;min-width:20rem;max-width:32rem}',
    '.pgx-sub.on{display:block}',
    '.pgx-opt{display:flex;align-items:center;justify-content:space-between;gap:1.2rem;width:100%;padding:.9rem 1.6rem;margin:0;background:none;border:0;color:#111;font:inherit;font-size:1.4rem;letter-spacing:.03em;text-align:left;cursor:pointer;white-space:nowrap}',
    '.pgx-opt .t{background:linear-gradient(' + RED + ',' + RED + ') 0 100%/0 2px no-repeat;transition:background-size .25s ease;padding-bottom:.2rem}',
    '.pgx-opt:hover .t,.pgx-opt:focus-visible .t,.pgx-opt.sel .t,.pgx-opt.act .t{background-size:100% 2px}',
    '.pgx-opt:focus-visible{outline:none}',
    '.pgx-opt.sel{font-weight:700}',
    '.pgx-opt .car{flex:0 0 auto;width:.6rem;height:.6rem;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(-45deg)}',
    '.pgx-opt .n{flex:0 0 auto;font-size:1.15rem;color:#666;font-weight:400}',
    '.pgx-hd{padding:.4rem 1.6rem .8rem;font-size:1.1rem;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#666}',
    '.pgx-acc{display:none;padding:0 0 .4rem 1.2rem;border-left:2px solid ' + RED + ';margin:0 1.6rem .4rem}',
    '.pgx-acc.on{display:block}',
    '.pgx-acc .pgx-opt{padding:.7rem 1rem;font-size:1.35rem}',
    '@media (max-width:749px){.pgx-panel{max-height:50vh}}',
    /* menu-style motion: list drops down, model menus slide out to the side */
    '.pgx.open .pgx-panel{animation:pgxDrop .22s cubic-bezier(.2,.7,.3,1)}',
    '.pgx-sub.on{animation:pgxSlide .22s cubic-bezier(.2,.7,.3,1)}',
    '.pgx-acc.on{animation:pgxDrop .2s ease}',
    '.pgx-opt .car{transition:transform .2s ease}',
    '.pgx-opt:hover .car,.pgx-opt.act .car{transform:translateX(3px) rotate(-45deg)}',
    '.pgx-opt .n{margin-left:auto}',
    '@keyframes pgxDrop{from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:none}}',
    '@keyframes pgxSlide{from{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:none}}',
    '@media (prefers-reduced-motion:reduce){.pgx.open .pgx-panel,.pgx-sub.on,.pgx-acc.on{animation:none}}',
    /* OEM wheels panel (Wheel Size Guide) */
    '.pgx-oem{margin-top:2.4rem;padding:2rem;background:#f3f3f4;border-top:3px solid ' + RED + ';color:#111}',
    '.pgx-oem h3{margin:0 0 .4rem;font-size:1.6rem;letter-spacing:.12em;text-transform:uppercase;color:#111}',
    '.pgx-oem p.sub{margin:0 0 1.6rem;font-size:1.35rem;color:#444}',
    '.pgx-oem-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(17rem,1fr));gap:1.2rem}',
    '.pgx-w{background:#fff;border:1px solid rgba(0,0,0,.08);display:flex;flex-direction:column}',
    '.pgx-w .b{padding:1.4rem 1.4rem 1.4rem 1.6rem;border-left:3px solid ' + RED + '}',
    '.pgx-w b{display:block;font-size:1.45rem;letter-spacing:.03em}',
    '.pgx-w span{display:block;margin-top:.4rem;font-size:1.25rem;line-height:1.45;color:#333}',
    '.pgx-w i{display:block;margin-top:.4rem;font-style:normal;font-size:1.15rem;color:#666}',
    '.pgx-oem .none{font-size:1.4rem;color:#333}'
  ].join('');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- data helpers ---------- */
  function trimsFor(make, model, year) {
    var k = make + '|' + model, raw = [(window.PG_TRIMS || {})[k], (window.PG_TRIMS_MORE || {})[k]].filter(Boolean).join(',');
    if (!raw || !year) return [];
    var out = [];
    raw.split(',').forEach(function (p) {
      var m = p.trim().match(/^(.*):(\d{4})-(\d{4})$/); if (!m) return;
      if (year >= +m[2] && year <= +m[3] && out.indexOf(m[1].trim()) < 0) out.push(m[1].trim());
    });
    return out;
  }
  /* the name customers know: "IS300" instead of "IS · IS300", "318i", "Vigor LS" */
  function dispName(model, trim) {
    if (!trim) return model;
    var base = String(model).replace(/\(.*?\)/g, '').replace(/-Class$/i, '').replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    var t = String(trim).replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    /* model designations stand alone: 330i, M340i, IS300, C300, E63 AMG, M3, 3.2TL */
    return (/^(\d{3}|\d\.\d[A-Z]{1,3}|[A-Z]{1,3}\d{1,3}(?![.\d]))/.test(trim) || (base && t.indexOf(base) === 0)) ? trim : model + ' ' + trim;
  }
  window.PG_DISPNAME = dispName;
  function oemFor(make, model, year, trim) {
    var list = (window.PG_OEM || {})[make + '|' + model] || [];
    return list.filter(function (w) {
      if (year < w[1] || year > w[2]) return false;
      if (trim && w[3] && w[3].indexOf(trim) < 0) return false;
      return true;
    });
  }

  /* ---------- context for a select ---------- */
  function scope(sel) { return sel.closest('.pg-tg, .pg-ymm, [data-pg-ymm], form, section') || document; }
  function valText(sel) {
    if (!sel) return '';
    var o = sel.options[sel.selectedIndex];
    return o && o.value !== '' ? o.textContent.trim() : '';
  }
  function ctx(sel) {
    var sc = scope(sel);
    var y = sc.querySelector('select[data-role="year"]'), mk = sc.querySelector('select[data-role="make"]'), md = sc.querySelector('select[data-role="model"]');
    var yt = valText(y);
    return { sc: sc, year: parseInt(yt, 10) || parseInt(y && y.value, 10) || 0, make: valText(mk), model: valText(md), modelSel: md, trim: md ? (md.dataset.trim || '') : '' };
  }

  /* ---------- custom dropdown ---------- */
  var openBox = null;
  function closeAll() {
    if (openBox) { openBox.classList.remove('open'); openBox = null; }
    document.querySelectorAll('.pgx-sub.on').forEach(function (s) { s.classList.remove('on'); });
    document.querySelectorAll('.pgx-opt.act').forEach(function (o) { o.classList.remove('act'); });
  }
  document.addEventListener('click', function (e) { if (openBox && !e.target.closest('.pgx') && !e.target.closest('.pgx-sub')) closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  window.addEventListener('scroll', function () { document.querySelectorAll('.pgx-sub.on').forEach(function (s) { s.classList.remove('on'); }); }, { passive: true });

  function enhance(sel) {
    if (sel.dataset.pgx) return;
    sel.dataset.pgx = '1';
    var role = sel.dataset.role;
    var box = document.createElement('div'); box.className = 'pgx pgx--' + role;
    sel.parentNode.insertBefore(box, sel); box.appendChild(sel);
    sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'pgx-btn'; btn.setAttribute('aria-haspopup', 'listbox');
    var panel = document.createElement('div'); panel.className = 'pgx-panel'; panel.setAttribute('role', 'listbox');
    box.appendChild(btn); box.appendChild(panel);
    var subs = [];
    var busy = false;

    function placeholder() { var o = sel.querySelector('option[value=""]'); return o ? o.textContent.trim() : (sel.getAttribute('aria-label') || role); }
    function sync() {
      var t = valText(sel), trim = role === 'model' ? (sel.dataset.trim || '') : '';
      btn.innerHTML = t ? '<span>' + esc(role === 'model' && trim ? dispName(t, trim) : t) + '</span>' : '<span class="ph">' + esc(placeholder()) + '</span>';
      btn.disabled = sel.disabled || !sel.querySelector('option:not([value=""])');
      btn.setAttribute('aria-label', (sel.getAttribute('aria-label') || role) + (t ? ': ' + t : ''));
    }
    function choose(v, trim) {
      busy = true;
      var changed = sel.value !== v || (sel.dataset.trim || '') !== (trim || '');
      sel.value = v;
      if (role === 'model') sel.dataset.trim = trim || '';
      closeAll();
      sync();
      if (changed) sel.dispatchEvent(new Event('change', { bubbles: true }));
      busy = false;
      if (role === 'model') document.dispatchEvent(new CustomEvent('pg:vehicle', { detail: ctx(sel) }));
      btn.focus({ preventScroll: true });
    }
    function build() {
      subs.forEach(function (s) { s.remove(); }); subs = [];
      panel.innerHTML = '';
      var c = role === 'model' ? ctx(sel) : null;
      Array.prototype.forEach.call(sel.options, function (o) {
        if (o.value === '') return;
        var label = o.textContent.trim();
        var trims = c ? trimsFor(c.make, label, c.year) : [];
        var b = document.createElement('button'); b.type = 'button'; b.className = 'pgx-opt' + (o.value === sel.value ? ' sel' : ''); b.setAttribute('role', 'option');
        b.innerHTML = '<span class="t">' + esc(trims.length === 1 ? dispName(label, trims[0]) : label) + '</span>' + (trims.length > 1 ? '<span class="n">' + trims.length + ' models</span><span class="car"></span>' : '');
        panel.appendChild(b);
        if (trims.length > 1) {
          var items = '<div class="pgx-hd">' + esc(label) + '</div><button type="button" class="pgx-opt" data-trim=""><span class="t">All ' + esc(label) + ' models</span></button>' +
            trims.map(function (t) { return '<button type="button" class="pgx-opt' + (o.value === sel.value && sel.dataset.trim === t ? ' sel' : '') + '" data-trim="' + esc(t) + '"><span class="t">' + esc(t) + '</span></button>'; }).join('');
          var sub = document.createElement('div'); sub.className = 'pgx-sub'; sub.innerHTML = items; document.body.appendChild(sub); subs.push(sub);
          var acc = document.createElement('div'); acc.className = 'pgx-acc'; acc.innerHTML = items.replace(/<div class="pgx-hd">.*?<\/div>/, ''); panel.appendChild(acc);
          [sub, acc].forEach(function (el) {
            el.addEventListener('click', function (e) { var t = e.target.closest('.pgx-opt'); if (t) choose(o.value, t.dataset.trim); });
          });
          var tHide;
          function showSub() {
            clearTimeout(tHide);
            subs.forEach(function (s) { if (s !== sub) s.classList.remove('on'); });
            panel.querySelectorAll('.pgx-opt.act').forEach(function (x) { x.classList.remove('act'); });
            b.classList.add('act');
            var r = b.getBoundingClientRect();
            sub.classList.add('on');
            var w = sub.offsetWidth, h = sub.offsetHeight;
            var left = r.right; if (left + w > window.innerWidth - 8) left = Math.max(8, r.left - w);
            var top = r.top - 8; if (top + h > window.innerHeight - 8) top = Math.max(8, window.innerHeight - 8 - h);
            sub.style.left = left + 'px'; sub.style.top = top + 'px';
          }
          function hideSub() { tHide = setTimeout(function () { sub.classList.remove('on'); b.classList.remove('act'); }, 200); }
          b.addEventListener('mouseenter', function () { if (mq.matches) showSub(); });
          b.addEventListener('mouseleave', function () { if (mq.matches) hideSub(); });
          sub.addEventListener('mouseenter', function () { clearTimeout(tHide); });
          sub.addEventListener('mouseleave', function () { hideSub(); });
          b.addEventListener('click', function () {
            if (mq.matches) { showSub(); return; }
            var on = !acc.classList.contains('on');
            panel.querySelectorAll('.pgx-acc.on').forEach(function (x) { x.classList.remove('on'); });
            acc.classList.toggle('on', on);
          });
        } else {
          b.addEventListener('click', function () { choose(o.value, trims[0] || ''); });
          b.addEventListener('mouseenter', function () { if (mq.matches) subs.forEach(function (s) { s.classList.remove('on'); }); });
        }
      });
      sync();
    }
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      if (box.classList.contains('open')) { closeAll(); return; }
      closeAll(); build(); box.classList.add('open'); openBox = box;
      var s = panel.querySelector('.pgx-opt.sel'); if (s) s.scrollIntoView({ block: 'nearest' });
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && !box.classList.contains('open')) { e.preventDefault(); btn.click(); var f = panel.querySelector('.pgx-opt'); if (f) f.focus(); }
    });
    panel.addEventListener('keydown', function (e) {
      var list = Array.prototype.slice.call(panel.querySelectorAll('.pgx-opt')).filter(function (x) { return x.offsetParent; });
      var i = list.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (list[i + 1] || list[0]).focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (list[i - 1] || list[list.length - 1]).focus(); }
    });
    new MutationObserver(function () { if (!busy) { if (role === 'model') sel.dataset.trim = ''; sync(); } })
      .observe(sel, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    sel.addEventListener('change', function () {
      if (busy) return;
      if (role === 'model') { sel.dataset.trim = ''; document.dispatchEvent(new CustomEvent('pg:vehicle', { detail: ctx(sel) })); }
      sync();
    });
    sync();
  }

  /* ---------- Factory (OEM) wheels panel in the Wheel Size Guide ---------- */
  function renderOEM(c) {
    if (!c || !c.sc || !c.sc.matches || !c.sc.matches('.pg-tg')) return;
    var host = c.sc.querySelector('.pgx-oem');
    if (!c.year || !c.make || !c.model) { if (host) host.remove(); return; }
    if (!host) {
      host = document.createElement('div'); host.className = 'pgx-oem';
      var anchor = c.sc.querySelector('[data-role="facts"]');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(host, anchor.nextSibling);
      else c.sc.appendChild(host);
    }
    var label = c.year + ' ' + c.make + ' ' + c.model + (c.trim ? ' ' + c.trim : '');
    var list = oemFor(c.make, c.model, c.year, c.trim);
    var html = '<h3>Factory (OEM) wheels</h3><p class="sub">Wheels that came from the factory on the ' + esc(label) + '.</p>';
    if (!list.length) {
      html += '<p class="none">Factory wheel details for this vehicle are coming soon. Call us at <a href="tel:+16268141350">(626) 814-1350</a> and we\u2019ll confirm your stock wheel sizes.</p>';
    } else {
      html += '<div class="pgx-oem-grid">' + list.map(function (w) {
        var who = w[3] ? w[3].join(', ') : 'All models';
        return '<div class="pgx-w"><div class="b"><b>' + esc(w[0]) + '</b><span>' + esc(w[4]) + '</span><i>' + esc(who) + ' \u00b7 ' + w[1] + (w[2] !== w[1] ? '\u2013' + w[2] : '') + '</i></div></div>';
      }).join('') + '</div>';
    }
    host.innerHTML = html;
  }
  document.addEventListener('pg:vehicle', function (e) { renderOEM(e.detail); });

  /* ---------- boot ---------- */
  function scan() {
    document.querySelectorAll('.pg-ymm select[data-role="year"], .pg-ymm select[data-role="make"], .pg-ymm select[data-role="model"], ' +
      '.pg-tg select[data-role="year"], .pg-tg select[data-role="make"], .pg-tg select[data-role="model"]').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { scan(); break; } })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
